import { PropertyType, PurchaseRuleTypes } from '@cubedelement.com/realty-investor-timeline';
import { IRuleConfig } from './IRuleConfig';
import { getPropertyIndex } from '../components/validators/PropertyOptions';

export const purchaseConfig: IRuleConfig = {
  panelTitle: 'Purchase Rules',
  collection: [
    {
      propertyType: getPropertyIndex(PropertyType.SingleFamily),
      ruleType: PurchaseRuleTypes.MinEstimatedAnnualCashFlow,
      description: 'Purchase if it meets minimum estimated annual profit from PITI, or cash flow',
      min: 0,
      max: 7200,
      prefix: '$',
      rule: 'PurchaseRuleTypes',
    },
    {
      propertyType: getPropertyIndex(PropertyType.SingleFamily),
      ruleType: PurchaseRuleTypes.MinEstimatedCapitalGainsPercent,
      description: 'The measure of the investment gain relative to the cost at which an asset was purchased',
      min: 0,
      max: 100,
      suffix: '%',
      rule: 'PurchaseRuleTypes',
    },
    {
      propertyType: getPropertyIndex(PropertyType.SingleFamily),
      ruleType: PurchaseRuleTypes.MinEstimatedCashOnCashPercent,
      description: 'Purchase if it meets minimum The ratio of annual cash flow to the total amount of cash invested in an income-producing asset.',
      min: 0,
      max: 100,
      suffix: '%',
      rule: 'PurchaseRuleTypes',
    },
    {
      propertyType: getPropertyIndex(PropertyType.SingleFamily),
      ruleType: PurchaseRuleTypes.MaxEstimatedOutOfPocket,
      description: 'Purchase if it meets minimum asking price. Your price with all of the fix ups done to the place.',
      min: 1000,
      max: 100000,
      prefix: '$',
      rule: 'PurchaseRuleTypes',
    },
    {
      propertyType: getPropertyIndex(PropertyType.SingleFamily),
      ruleType: PurchaseRuleTypes.MinAskingPrice,
      description: 'Purchase if it meets minimum asking price (percentage of cost down)',
      min: 0,
      max: 100000,
      prefix: '$',
      rule: 'PurchaseRuleTypes',
    },
    {
      propertyType: getPropertyIndex(PropertyType.SingleFamily),
      ruleType: PurchaseRuleTypes.MinAfterRepairPrice,
      description: 'Purchase if it meets minimum after repair price. (You purchased it below value, and you have rehabbed it).',
      min: 0,
      max: 100000,
      prefix: '$',
      rule: 'PurchaseRuleTypes',
    },

    {
      propertyType: getPropertyIndex(PropertyType.PassiveApartment),
      ruleType: PurchaseRuleTypes.MinEstimatedAnnualCashFlow,
      description: 'Purchase if it meets minimum estimated annual profit from PITI, or cash flow',
      min: 0,
      max: 10000,
      prefix: '$',
      rule: 'PurchaseRuleTypes',
    },
    {
      propertyType: getPropertyIndex(PropertyType.PassiveApartment),
      ruleType: PurchaseRuleTypes.MinEstimatedCapitalGainsPercent,
      description: 'The measure of the investment gain relative to the cost at which an asset was purchased',
      min: 0,
      max: 100,
      suffix: '%',
      rule: 'PurchaseRuleTypes',
    },
    {
      propertyType: getPropertyIndex(PropertyType.PassiveApartment),
      ruleType: PurchaseRuleTypes.MinEstimatedCashOnCashPercent,
      description: 'Purchase if it meets minimum The ratio of annual cash flow to the total amount of cash invested in an income-producing asset.',
      min: 0,
      max: 100,
      suffix: '%',
      rule: 'PurchaseRuleTypes',
    },
    {
      propertyType: getPropertyIndex(PropertyType.PassiveApartment),
      ruleType: PurchaseRuleTypes.MaxEstimatedOutOfPocket,
      description: 'Purchase if it meets minimum asking price (percentage of cost down)',
      min: 1000,
      max: 100000,
      prefix: '$',
      rule: 'PurchaseRuleTypes',
    },
    {
      propertyType: getPropertyIndex(PropertyType.PassiveApartment),
      ruleType: PurchaseRuleTypes.MinAskingPrice,
      description: 'Purchase if it meets minimum asking price (percentage of cost down)',
      min: 0,
      max: 400000,
      prefix: '$',
      rule: 'PurchaseRuleTypes',
    },
    {
      propertyType: getPropertyIndex(PropertyType.PassiveApartment),
      ruleType: PurchaseRuleTypes.MinAfterRepairPrice,
      description: 'Purchase if it meets minimum after repair price. (You purchased it below value, and you have rehabbed it).',
      min: 0,
      max: 200000000,
      prefix: '$',
      rule: 'PurchaseRuleTypes',
    },
  ],
};
